import type { DynapacLoginDetails } from '@shared/dynapacTypes';

export const loginDetails: DynapacLoginDetails = {
	email: 'surfacing.seq@fultonhogan.com.au',
	password: 'FHSEQ01',
};